class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    const caretSvg = `
     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" viewBox="0 0 19 11" fill="none">
       <path d="M18 1L9.5 9L1 0.999999" stroke="#2E365D" stroke-width="2" stroke-linecap="round"/>
     </svg>
    `;

    const title = this.getAttribute('title');
    const titleEl = document.createElement('button');
    titleEl.type = 'button';
    titleEl.ariaExpanded = false;
    titleEl.setAttribute('slot', 'title');
    titleEl.innerHTML = `
      <span slot="value"></span>
      <span slot="placeholder">${title}</span>
      ${caretSvg}
    `;

    this.insertBefore(titleEl, this.firstChild);

    // Store references
    this.titleEl = titleEl;
    this.optionsEl = this.querySelector('ul');

    // Add events
    this.titleEl.addEventListener('click', this.toggleDropdown.bind(this));
    this.optionsEl.addEventListener(
      'click',
      this.handleOptionsClick.bind(this)
    );

    // State
    this._isOpen = false;
    this._value = this.getAttribute('value');

    if (this._value !== '') {
      this.value = this._value;
    }
  }

  handleKeyDown = event => {
    if (event.key === 'Escape') {
      this.isOpen = false;
      return;
    }

    if (event.key === 'ArrowUp') {
      this.selectPreviousOption();
      event.preventDefault();
      return;
    }

    if (event.key === 'ArrowDown') {
      this.selectNextOption();
      event.preventDefault();
      return;
    }

    if (event.key === ' ') {
      this.value = document.activeElement.dataset.value;
      event.preventDefault();
      return;
    }
  };

  handleDocumentClick = event => {
    if (!this.contains(event.target)) {
      this.isOpen = false;
    }
  };

  handleOptionsClick(event) {
    if (event.target.tagName === 'BUTTON') {
      this.value = event.target.dataset.value;
    }
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    if (value) {
      this.classList.add('is-open');
      this.addEventListener('keydown', this.handleKeyDown);
      document.addEventListener('click', this.handleDocumentClick);
    } else {
      this.classList.remove('is-open');
      this.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('click', this.handleDocumentClick);
    }
    this._isOpen = value;
  }

  toggleDropdown() {
    this.isOpen = !this._isOpen;
  }

  get value() {
    return this._value;
  }

  set value(newValue) {
    const anchor = this.optionsEl.querySelector(
      `button[data-value="${newValue}"]`
    );

    this._value = newValue;
    this.isOpen = false;

    if (anchor) {
      const selectedText = anchor.dataset.label.trim();
      this.titleEl.querySelector("span[slot='value']").innerHTML = selectedText;
    } else {
      this.titleEl.querySelector("span[slot='value']").innerHTML = '';
    }

    const changeEvent = new CustomEvent('change', {
      detail: {
        value: newValue,
      },
    });
    this.dispatchEvent(changeEvent);
  }

  selectPreviousOption() {
    const active = document.activeElement;
    if (!active) {
      return;
    }

    if (active === this.titleEl) {
      this.querySelector('li:last-child button').focus();
      return;
    }

    if (active.tagName !== 'BUTTON') {
      return;
    }

    const prevEl = active.parentElement.previousElementSibling;

    if (prevEl && prevEl.firstChild.tagName === 'BUTTON') {
      prevEl.firstChild.focus();
    }
  }

  selectNextOption() {
    const active = document.activeElement;
    if (!active) {
      return;
    }

    if (active === this.titleEl) {
      this.querySelector('li button').focus();
      return;
    }

    if (active.tagName !== 'BUTTON') {
      return;
    }

    const nextEl = active.parentElement.nextElementSibling;

    if (nextEl && nextEl.firstChild.tagName === 'BUTTON') {
      nextEl.firstChild.focus();
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);
